import { useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Check, X, Plus } from "lucide-react";
import { toast } from "sonner";

// Inline create of a fair card; with `model` set only the color is asked
export default function FairQuickCard({ model, onCreated, testId, label, open: forced, onClose }) {
  const [own, setOwn] = useState(false);
  const open = forced ?? own;
  const setOpen = (v) => (onClose && !v ? onClose() : setOwn(v));
  const [code, setCode] = useState("");
  const [color, setColor] = useState("");

  const save = async () => {
    try {
      const r = await api.post("/fair/products", { model_code: model || code, model_color: color });
      await onCreated(r.data);
      toast.success(`${r.data.model_code} ${r.data.model_color} oluşturuldu`);
      setOpen(false); setCode(""); setColor("");
    } catch (e) { toast.error(e.response?.data?.detail || "Hata"); }
  };

  if (!open && forced !== undefined) return null;
  if (!open) {
    return (
      <Button type="button" variant="outline" onClick={() => setOpen(true)} data-testid={`${testId}-btn`}
        className="h-10 border-dashed border-[#D97706]/60 bg-transparent text-[#B45309] hover:bg-[#FFFBF4]">
        <Plus className="w-4 h-4 mr-1" /> {label}
      </Button>
    );
  }
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={`${testId}-form`}>
      {!model && <Input autoFocus placeholder="Model kodu *" value={code} onChange={(e) => setCode(e.target.value)}
        data-testid={`${testId}-code`} className="h-10 w-40 bg-[#FFFBF4] border-[#DCCFB8]" />}
      <Input autoFocus={!!model} placeholder="Renk *" value={color} onChange={(e) => setColor(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && save()} data-testid={`${testId}-color`} className="h-10 w-40 bg-[#FFFBF4] border-[#DCCFB8]" />
      <Button type="button" onClick={save} data-testid={`${testId}-save`} className="h-10 bg-[#D97706] hover:bg-[#B45309] text-white">
        <Check className="w-4 h-4 mr-1" /> Oluştur</Button>
      <button type="button" onClick={() => setOpen(false)} data-testid={`${testId}-cancel`} className="text-[#8C7B68] hover:text-[#EF4444]"><X className="w-4 h-4" /></button>
    </div>
  );
}
